@if (team$ | async; as currentTeam) {
    <div *adaptLoadingUntilFirstEmit="let nodes of hierarchy$">
        <dx-tree-view [items]="nodes"
                      keyExpr="hierarchyId"
                      displayExpr="name"
                      itemsExpr="children"
                      itemTemplate="itemTemplate"
                      [selectByClick]="false"
                      [selectNodesRecursive]="false"
                      [class.team-hierarchy-full-context]="showMoreContext$ | async"
                      (onItemRendered)="onItemRendered($event)"
                      (onItemClick)="onItemClicked($event)">
            <div *dxTemplate="let item of 'itemTemplate'">
                @if (asHierarchyNode(item); as node) {
                    @if (node.type === TeamHierarchyNodeType.Zone) {
                        <div class="d-flex align-items-center">
                            <i [class]="node.icon + ' ms-1 me-2 zone-icon'"
                               [style.color]="node.colour"></i>
                            <span class="fw-bold">{{node.name}} zone</span>
                        </div>
                    } @else {
                        <div class="team-hierarchy-node"
                             [class.opacity-75]="!node.entity?.isActive()">
                            <adapt-link-team [team]="node.entity"
                                             [adaptLinkDisabled]="node.id === currentTeam.teamId"
                                             [showChildCount]="true"
                                             [showIcon]="true"
                                             [showIconBorder]="node.id === currentTeam.teamId"
                                             [showLabels]="true"
                                             class="team-hierarchy-node-details"></adapt-link-team>

                            <adapt-team-inactive-badge [team]="node.entity"
                                                       badgeClass="ms-1"></adapt-team-inactive-badge>

                            @if (showPeople) {
                                <adapt-team-membership [team]="node.entity"
                                                       class="team-hierarchy-node-members"
                                                       imageSize="xs"></adapt-team-membership>
                            }
                        </div>
                    }
                }
            </div>
        </dx-tree-view>
    </div>
}
